import { RotatorCampaignIdSchema as m } from "@hprofits/shared";
import { PrivilegeEnum as t } from "@hprofits/shared/auth";
import { z as e } from "zod";
import "../common/acl-view.js";
import { ocPrivate as r } from "../common/auth/procedure-builders.js";
import { createCreationResultSchema as i } from "../common/creation-result.js";
import "../common/owner.js";
import { RotatorCampaignIdParamSchema as s, PricingRuleIdParamSchema as n } from "../common/params.js";
import "../common/errors/constants.js";
import { notFoundError as o, alreadyExistsError as p } from "../common/errors/contract.js";
import "../common/errors/schemas.js";
import "../swagger/security.js";
import { SwaggerTags as a } from "../swagger/tags.js";
import { UpdateRotatorCampaignSchema as u, CreateRotatorCampaignSchema as d, RotatorCampaignListSchema as g } from "./schemas.js";
const v = {
  rotatorCampaign: {
    findAll: r([t.ReadAdmin]).route({
      method: "GET",
      path: "/rules/{ruleId}/rotator-campaigns",
      summary: "List the rotator settings of a pricing rule",
      tags: [a.ROTATOR_CAMPAIGNS.name]
    }).input(n).output(g).errors({
      ...o("Rule not found")
    }),
    create: r([t.WriteAdmin]).route({
      method: "POST",
      path: "/rules/{ruleId}/rotator-campaigns",
      summary: "Add rotator settings to a pricing rule",
      tags: [a.ROTATOR_CAMPAIGNS.name],
      successStatus: 201
    }).input(d).output(i(m)).errors({
      ...o("Rule not found"),
      ...p("The rule already has settings for this experiment")
    }),
    update: r([t.WriteAdmin]).route({
      method: "PUT",
      path: "/rotator-campaigns/{rotatorCampaignId}",
      summary: "Update rotator settings",
      tags: [a.ROTATOR_CAMPAIGNS.name],
      successStatus: 204
    }).input(u).output(e.void()).errors({
      ...o("Rotator settings not found")
    }),
    remove: r([t.WriteAdmin]).route({
      method: "DELETE",
      path: "/rotator-campaigns/{rotatorCampaignId}",
      summary: "Delete rotator settings",
      tags: [a.ROTATOR_CAMPAIGNS.name],
      successStatus: 204
    }).input(s).output(e.void()).errors({
      ...o("Rotator settings not found")
    })
  }
};
export {
  v as rotatorCampaignContract
};
//# sourceMappingURL=contract.js.map
